<template lang="html">

  <section class="banner-newsletter">

    <div class="container">

      <h2 class="secondary-title row-center">
        {{$t('bannerNewsletter.titulo')}}
        <img src="/static/img/top.svg" alt="">
      </h2>

      <h3>{{$t('bannerNewsletter.claim')}}</h3>

      <form class="formulario-newsletter row-center" :show="showall" @submit.prevent="validateBeforeSubmit">
        <div class="contenedor-input">
          <input class="input-text" type="text" name="email" :placeholder="$t('bannerNewsletter.placeholder')" @focus="showall= true" v-model="data.email" v-validate="'required|email'">
          <span class="error animated shake" v-if="errors.has('email')">{{ errors.first('email') }}</span>
        </div>

        <div class="contenedor-campos row-between ais" :show="showall">

          <h2>{{$t('bannerNewsletter.subtitulo')}}</h2>

          <div class="contenedor-input -middle">
            <input name="name" class="input-text" type="text" :placeholder="$t('formulario.nombre')+'*'" v-model="data.name" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('name')">{{ errors.first('name') }}</span>
          </div>
          <div class="contenedor-input -middle">
            <input name="firstName" class="input-text" type="text" :placeholder="$t('formulario.primerapellido')+'*'" v-model="data.firstName" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('firstName')">{{ errors.first('firstName') }}</span>
          </div>
          <div class="contenedor-input -middle">
            <input name="lastName" class="input-text" type="text" :placeholder="$t('formulario.segundoapellidos')" v-model="data.lastName" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('lastName')">{{ errors.first('lastName') }}</span>
          </div>
          <div class="contenedor-input -middle">
            <input name="birthday" class="input-text" @focus="nacimientotype= 'date'" :type="nacimientotype" :placeholder="$t('formulario.fechanacimiento')" v-model="data.birthday" v-validate="'required'">
            <span class="error animated shake" v-if="errors.has('birthday')">{{ errors.first('birthday') }}</span>
          </div>


          <div class="contenedor-input -middle">
          <select class="select" name="provincia" id="" v-model="data.province" v-validate="'required'">
            <option value="">Provincia</option>
            <option value='alava'>Álava</option>
            <option value='albacete'>Albacete</option>
            <option value='alicante'>Alicante/Alacant</option>
            <option value='almeria'>Almería</option>
            <option value='asturias'>Asturias</option>
            <option value='avila'>Ávila</option>
            <option value='badajoz'>Badajoz</option>
            <option value='barcelona'>Barcelona</option>
            <option value='burgos'>Burgos</option>
            <option value='caceres'>Cáceres</option>
            <option value='cadiz'>Cádiz</option>
            <option value='cantabria'>Cantabria</option>
            <option value='castellon'>Castellón/Castelló</option>
            <option value='ceuta'>Ceuta</option>
            <option value='ciudadreal'>Ciudad Real</option>
            <option value='cordoba'>Córdoba</option>
            <option value='cuenca'>Cuenca</option>
            <option value='girona'>Girona</option>
            <option value='laspalmas'>Las Palmas</option>
            <option value='granada'>Granada</option>
            <option value='guadalajara'>Guadalajara</option>
            <option value='guipuzcoa'>Guipúzcoa</option>
            <option value='huelva'>Huelva</option>
            <option value='huesca'>Huesca</option>
            <option value='illesbalears'>Illes Balears</option>
            <option value='jaen'>Jaén</option>
            <option value='acoruña'>A Coruña</option>
            <option value='larioja'>La Rioja</option>
            <option value='leon'>León</option>
            <option value='lleida'>Lleida</option>
            <option value='lugo'>Lugo</option>
            <option value='madrid'>Madrid</option>
            <option value='malaga'>Málaga</option>
            <option value='melilla'>Melilla</option>
            <option value='murcia'>Murcia</option>
            <option value='navarra'>Navarra</option>
            <option value='ourense'>Ourense</option>
            <option value='palencia'>Palencia</option>
            <option value='pontevedra'>Pontevedra</option>
            <option value='salamanca'>Salamanca</option>
            <option value='segovia'>Segovia</option>
            <option value='sevilla'>Sevilla</option>
            <option value='soria'>Soria</option>
            <option value='tarragona'>Tarragona</option>
            <option value='santacruztenerife'>Santa Cruz de Tenerife</option>
            <option value='teruel'>Teruel</option>
            <option value='toledo'>Toledo</option>
            <option value='valencia'>Valencia/Valéncia</option>
            <option value='valladolid'>Valladolid</option>
            <option value='vizcaya'>Vizcaya</option>
            <option value='zamora'>Zamora</option>
            <option value='zaragoza'>Zaragoza</option>
          </select>
          <span class="error animated shake" v-if="errors.has('provincia')">{{ errors.first('provincia') }}</span>
          </div>

          <div class="contenedor-radios -middle row-center">
            <div class="contenedor-check">
              <input type="radio" id="sexo-hombre" value="hombre" name="sexo" v-model="data.sex" v-validate="'required'">
              <label for="sexo-hombre">{{$t('formulario.hombre')}}</label>
            </div>
            <div class="contenedor-check">
              <input type="radio" id="sexo-mujer" value="mujer" name="sexo" v-model="data.sex" v-validate="'required'">
              <label for="sexo-mujer">{{$t('formulario.mujer')}}</label>
            </div>
            <span class="error animated shake" v-if="errors.has('sexo')">{{ errors.first('sexo') }}</span>
          </div>

          <p v-html="$t('bannerNewsletter.legal')"></p>


          <div class="contenedor-check">
            <input type="checkbox" id="politicanewsletter" v-validate="'required'" name="politicanewsletter" v-model="data.privacy">
            <label for="politicanewsletter">{{$t('formulario.he_leido')}} <router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{$t('formulario.y_acepto')}}</router-link>
              {{$t('formulario.de_fiesta')}}</label>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politicanewsletter') }}</span>
          </div>

          <div class="contenedor-check">
            <input type="checkbox" id="comunicacionesnewsletter" name="comunicacionesnewsletter" v-validate="'required'" v-model="data.marketing">
            <label for="comunicacionesnewsletter">{{$t('formulario.comunicaciones')}}</label>
            <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('comunicacionesnewsletter') }}</span>
          </div>

          <button class="btn-enviar -enviar-pink" :loading="loading" :enviado-word="$t('formulario.enviado')" :enviado="enviado">{{$t('formulario.finalizar')}}</button>

          <a @click="showall= false" title="cerrar" class="cerrar">Cerrar</a>


        </div>



      </form>



    </div>

    <img src="/static/img/background-newsletter.png" class="background-newsletter" alt="background">
    <img class="fresquito" src="/static/img/fresquito-to-right.png" alt="Imagen de fresquito">

  </section>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex';


    export default  {
      name: 'banner-newsletter',
      data(){
        return{
          nacimientotype : 'text',
          showall : false,
          clicked : false,
          loading : false,
          enviado : false,
          data : {
            'email' : '',
            'name' :  '',
            'firstName' : '',
            'lastName' : '',
            'province' : '',
            'marketing' : false,
            'privacy' : false,
            'fieldValues' : {
                'sex' :'',
                'province' : '',
                'birthday' : '',
            }
          }
        }
      },
      methods : {
        ...mapActions(['sendNewsletter']),
        validateBeforeSubmit : function(){
        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.loading = true;
            this.sendNewsletter(this.data).then(r => {
              if(r){
                this.enviado = true;
                this.data = '';
                
                setTimeout(e => {
                  this.showall = false;
                },1000)
              }
            })
          }
        });
},
      },
      watch : {
      '$route'(){
        this.showall = false;
      }
    }
    }
  </script>

<style scoped lang="scss">

  </style>


// WEBPACK FOOTER //
// src/components/parts/banner-newsletter.vue